module.exports = __webpack_public_path__ + "img/20201204_134139.5956eda8.jpg";